<template>
  <div class="request-approval-container" v-if="$get($store, 'state.permissions.70.allow')">
    <Email v-show="$store.state.modalStore.showNewVendorEmail" />
    <div class="request-approval-dialog">
      <div class="request-approval-content">
        <div class="request-approval-body">
          <!-- <div class="modal-button-close">
              <i class="far fa-times-circle" @click="closeModal()"></i>
            </div> -->
          <div class="req-app-full-container">
            <div class="req-app-full-tittle">TIKET VENDOR BARU</div>
            <div class="req-app-full-wrapper">
              <div class="req-app-half-container">
                <div class="half-input-wrapper">
                  <div class="hiw-label">Request ID</div>
                  <input type="text" class="hiw-text" placeholder="Otomatis dari Sistem" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Deskripsi <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="desc" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Pengadaan <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="nama_pengadaan" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Kategori</div>
                  <select v-model="kategori_id" class="hiw-text">
                    <option v-for="(option, index) in kategoryList" :key="index" :value="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="nama_vendor" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    PIC Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="pic_vendor" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Email Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="email" class="hiw-text" v-model="email_vendor" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Priority</div>
                  <select v-model="priority" class="hiw-text">
                    <option v-for="(option, index) in priorityList" :key="index" :value="option.id">
                      {{ option.desc }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="req-app-half-container">
                <div class="half-input-wrapper">
                  <div class="hiw-label">Due By</div>
                  <div class="hiw-multiple">
                    <input class="hiw-2-row" type="date" />
                    <input class="hiw-2-row" type="date" />
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Bidang Usaha</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="radio" value="1" v-model="bidang_usaha_id"
                        style="margin-right: 10px" />Badan Usaha</label>
                    <label class="hiw-2-row"><input type="radio" value="2" v-model="bidang_usaha_id"
                        style="margin-right: 10px" />Perorangan</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Registrasi ke Sistem <span class="text-ast">*</span>
                  </div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_ariba" value="1"
                        style="margin-right: 10px" :disabled="freeze_ariba" />ARIBA</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_gems" value="1"
                        style="margin-right: 10px" :disabled="freeze_gems" />SAP GEMS</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bce" value="1"
                        style="margin-right: 10px" :disabled="freeze_bce" />SAP BCE</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bkes" value="1"
                        style="margin-right: 10px" :disabled="freeze_bkes" />SAP BKES</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Tipe Pendaftaran Vendor</div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row"><input type="radio" value="1" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Nasional</label>
                    <label class="hiw-4-row"><input type="radio" value="2" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Internasional</label>
                    <label class="hiw-4-row"><input type="radio" value="3" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Khusus</label>
                    <label class="hiw-4-row"><input type="radio" value="4" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Internal Memo <i class="fas fa-upload"></i>
                    </label>
                    <input type="file" class="hiw-text" v-show="type_pendaftaran_id == '4'" />
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Penilaian</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_k3l" value="k3l"
                        style="margin-right: 10px" :disabled="freeze_k3l" />K3L</label>
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_kplh" value="kplh"
                        style="margin-right: 10px" :disabled="freeze_kplh" />KPLH</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Document Legalitas</div>
                  <!-- <input type="file" class="hiw-text"> -->
                  <label class="btn btn-default btn-file">
                    <i class="fas fa-upload"></i> {{ theFileName }}
                    <input type="file" style="display: none;" @change="fileChangeHandler" />
                  </label>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Note</div>
                  <textarea class="hiw-area" v-model="note" />
                </div>
              </div>
            </div>
            <div class="req-app-full-btn-wrapper">
              <div class="req-app-btn-submit mr10" @click="approve()">
                Approve
              </div>
              <div class="req-app-btn-submit mr10" @click="reject()">
                Reject
              </div>
              <div class="req-app-btn-submit mr10" @click="reviseNow()">
                Revise Now
              </div>
              <div class="req-app-btn-submit mr10" @click="needReview()">
                Need Review
              </div>
              <div class="req-app-btn-submit mr10" @click="postpone()">
                Postpone
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../services/config'
export default {
  components: {
    Email: () => import('@/components/modal/newVendorEmail.vue'),
  },
  data() {
    return {
      chooseBu: '',
      chooseTypeRegister: '',
      chooseAssesment: [],
      chooseServer: [],
      files: [],

      priorityList: [
        {
          id: 1,
          desc: 'Very High',
        },
        {
          id: 2,
          desc: 'High',
        },
        {
          id: 3,
          desc: 'Medium',
        },
        {
          id: 4,
          desc: 'Low',
        },
        {
          id: 5,
          desc: 'Very Low',
        },
      ],
      kategoryList: [
        {
          id: 1,
          desc: 'CAT - CATEGORY 1',
        },
        {
          id: 2,
          desc: 'GIL - GA,IT & LONG TAILS',
        },
        {
          id: 3,
          desc: 'FEL - FUEL, LUBRICANT & ENERGY',
        },
        {
          id: 4,
          desc: 'MRR - MAINTENANCE & REPAIR, RENTAL',
        },
        {
          id: 5,
          desc: 'CPI - COAL PROCESSING & INFRASTRUCTURE PROJECT',
        },
      ],
      tujuan_list: [],

      code: '',
      desc: '',
      nama_pengadaan: '',
      kategori_id: 1,
      nama_vendor: '',
      pic_vendor: '',
      no_telepon: '',
      email_vendor: '',
      priority: 5,

      //due_date:,
      bidang_usaha_id: 1,
      type_pendaftaran_id: 1,
      register_gems: false,
      register_bce: false,
      register_bkes: false,
      assesment_k3l: false,
      assesment_kplh: false,
      note: '',
    }
  },
  async created() {
    await this.getVendorCategory()
  },
  computed: {
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
  },
  watch: {
    tujuan_pendaftaran(newValue) {
      if (this.tujuan_list.length > 0) {
        const { ariba_registration, gems_registration, bce_registration, bkes_registration } = this.tujuan_list.filter(
          i => i.id == newValue
        )[0]

        if (newValue == 1 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 1 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 2 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 2 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 3 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 3 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 4 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 4 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 5 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 5 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        }
      }
    },
  },
  methods: {
    async getVendorCategory() {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/m-ticket-category`,
        })

        this.kategoryList = data.data
      } catch (error) {
        // do nothing
      }
    },
    resetForm() {
      this.desc = ''
      this.nama_pengadaan = ''
      this.kategori_id = 1
      this.nama_vendor = ''
      this.pic_vendor = ''
      this.no_telepon = ''
      this.priority = 5
      this.bidang_usaha_id = 1
      this.type_pendaftaran_id = 1
      this.register_gems = false
      this.register_bce = false
      this.register_bkes = false
      this.assesment_k3l = false
      this.assesment_kplh = false
      this.note = null
      this.files = []
      this.email_vendor = ''
    },
    showModal() {
      const request = {
        desc: this.desc,
        nama_pengadaan: this.nama_pengadaan,
        kategori_id: this.kategori_id,
        nama_vendor: this.nama_vendor,
        pic_vendor: this.pic_vendor,
        no_telepon: this.no_telepon,
        priority: this.priority,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        register_gems: this.register_gems,
        register_bce: this.register_bce,
        register_bkes: this.register_bkes,
        assesment_k3l: this.assesment_k3l,
        assesment_kplh: this.assesment_kplh,
        note: this.note,
      }

      if (this.files && this.files.length > 0) {
        request['dokumen_legalitas'] = this.files[0]
      }

      if (
        this.desc &&
        this.desc != '' &&
        this.nama_pengadaan &&
        this.nama_pengadaan != '' &&
        this.nama_vendor &&
        this.nama_vendor != '' &&
        this.pic_vendor &&
        this.pic_vendor != '' &&
        this.email_vendor &&
        this.email_vendor != ''
      ) {
        this.$store.commit('modalStore/SET_MODAL_STATE', {
          name: 'dataRequest',
          value: request,
        })
        this.$store.commit('modalStore/SET_MODAL_STATE', {
          name: 'emailRequest',
          value: this.email_vendor,
        })
        this.$store.commit('modalStore/SHOW_NEW_VENDOR_EMAIL')
      } else {
        this.$store.commit('SET_NOTIF', 'Silakan lengkapi data')
      }
    },
    submitRequest() {
      const self = this
      let url = `${api}/api/v1/pendaftaran`

      const request = {
        desc: this.desc,
        nama_pengadaan: this.nama_pengadaan,
        kategori_id: this.kategori_id,
        nama_vendor: this.nama_vendor,
        pic_vendor: this.pic_vendor,
        no_telepon: this.no_telepon,
        priority: this.priority,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        register_gems: this.register_gems,
        register_bce: this.register_bce,
        register_bkes: this.register_bkes,
        assesment_k3l: this.assesment_k3l,
        assesment_kplh: this.assesment_kplh,
        note: this.note,
      }

      if (this.files && this.files.length > 0) {
        request['dokumen_legalitas'] = this.files[0]
      }

      if (
        request.desc &&
        request.desc != '' &&
        request.nama_pengadaan &&
        request.nama_pengadaan != '' &&
        request.nama_vendor &&
        request.nama_vendor != '' &&
        request.pic_vendor &&
        request.pic_vendor != '' &&
        this.email_vendor &&
        this.email_vendor != ''
      ) {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        let bodyFormData = new FormData()
        request.documen_legalitas &&
          bodyFormData.append('dokumen_legalitas', data.dokumen_legalitas)
        this.email_vendor &&
          this.email_vendor != '' &&
          bodyFormData.append('email_vendor', this.email_vendor)
        bodyFormData.append('desc', request.desc)
        bodyFormData.append('nama_pengadaan', request.nama_pengadaan)
        bodyFormData.append('kategori_id', request.kategori_id)
        bodyFormData.append('nama_vendor', request.nama_vendor)
        bodyFormData.append('pic_vendor', request.pic_vendor)
        bodyFormData.append('priority', request.priority)
        bodyFormData.append('bidang_usaha_id', request.bidang_usaha_id)
        bodyFormData.append('type_pendaftaran_id', request.type_pendaftaran_id)
        bodyFormData.append('register_gems', request.register_gems)
        bodyFormData.append('register_bce', request.register_bce)
        bodyFormData.append('register_bkes', request.register_bkes)
        bodyFormData.append('assesment_k3l', request.assesment_k3l)
        bodyFormData.append('assesment_kplh', request.assesment_kplh)
        bodyFormData.append('note', request.note)

        axios({
          method: 'post',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(function (response) {
            this.$store.commit('SET_NOTIF', 'Permintaan Anda sedang di Proses')

            self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
            self.resetForm()
          })
          .catch(function (error) {
            self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
            $store.commit(
              'SET_NOTIF',
              this.$get(error, 'response.data.message', 'Error')
            )
          })
      } else {
        this.$store.commit('SET_NOTIF', 'Silahkan lengkapi data')
      }
    },
    closeModal() {
      this.$store.commit('modalStore/SET_REQ_NEW_VENDOR_MODAL', false)
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
    approve() {
      if (this.$get(this.$store, 'state.permissions.77.allow')) {
        this.$store.commit(
          'SET_NOTIF',
          'Maaf, Fitur sedang dalam pengembangan.'
        )
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    reject() {
      if (this.$get(this.$store, 'state.permissions.78.allow')) {
        this.$store.commit(
          'SET_NOTIF',
          'Maaf, Fitur sedang dalam pengembangan.'
        )
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    reviseNow() {
      if (this.$get(this.$store, 'state.permissions.79.allow')) {
        this.$store.commit(
          'SET_NOTIF',
          'Maaf, Fitur sedang dalam pengembangan.'
        )
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    needReview() {
      if (this.$get(this.$store, 'state.permissions.80.allow')) {
        this.$store.commit(
          'SET_NOTIF',
          'Maaf, Fitur sedang dalam pengembangan.'
        )
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    postpone() {
      if (this.$get(this.$store, 'state.permissions.81.allow')) {
        this.$store.commit(
          'SET_NOTIF',
          'Maaf, Fitur sedang dalam pengembangan.'
        )
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
  },
}
</script>
